module.exports = __webpack_public_path__ + "img/background-twism.3458ad31.svg";